import useGetDataFromRDB from './useGetDataFromRDB'

export default useGetDataFromRDB
